import React, { useState, useEffect, Fragment } from 'react';
import { RadioField } from '@zola/zola-ui';
import cx from 'classnames';
import _isEmpty from 'lodash/isEmpty';

import ZoomPlanStatusModule from 'components/manage/VirtualEvents/ZoomPlanStatusModule';
import CreateZoomEventForm from 'components/manage/VirtualEvents/CreateZoomEventForm';
import ExistingZoomLinkForm from 'components/manage/VirtualEvents/ExistingZoomLinkForm';
import ZoomEventDetailsModule from 'components/manage/VirtualEvents/ZoomEventDetailsModule';
import Loader from 'components/common/ui/Loader';

import usePrevious from '../../../hooks/usePrevious';
import { parseStartTime, getEventDuration } from '../../../../util/formDataUtil';

import css from './zoomCreate.module.less';
import './zoomCreate.less';

const ZoomCreate = ({ zoomEvent, eventHash, fetchEventByHash }) => {
  const {
    virtual_meeting: virtualMeeting = {},
    name,
    type,
    timezone,
    start_at: startAt,
    end_at: endTime,
    id: eventId,
  } = zoomEvent;
  const { join_url: zoomLink, meeting_id: zoomMeetingId, source } = virtualMeeting;
  const [selectedForm, setSelectedForm] = useState();
  const [formState, saveFormState] = useState(null);
  const [isUpdate, setIsUpdate] = useState(eventHash !== 'new' && eventHash !== undefined);
  const [isReview, setIsReview] = useState(false);

  const handleSelectForm = e => {
    const isChecked = e.target.id === selectedForm;
    if (isChecked) return setSelectedForm(null);
    return setSelectedForm(e.target.id);
  };

  const { date, startTime } = parseStartTime(startAt, timezone);
  const initialDuration = getEventDuration(startAt, endTime);
  const existingEventInitialValues = {
    date,
    startTime,
    timezone,
    zoomLink,
    zoomMeetingId,
    name,
    type,
    eventId,
    duration: initialDuration,
  };

  useEffect(() => {
    if (eventHash && _isEmpty(zoomEvent)) fetchEventByHash(eventHash);
  }, []);

  const prevSource = usePrevious(source);
  useEffect(() => {
    if (prevSource === undefined && prevSource !== source) {
      const mapSource = {
        API: 'needLink',
        MANUAL: 'haveLink',
      };
      setSelectedForm(mapSource[source]);
    }
  }, [prevSource, source, setSelectedForm]);

  const handleSetIsReview = bool => {
    setIsReview(bool);
  };

  const handleSetIsUpdate = bool => {
    setIsUpdate(bool);
  };

  const handleSaveFormState = form => {
    saveFormState(form);
  };

  if (eventHash && _isEmpty(zoomEvent)) {
    return (
      <div className={cx(css.loadingContainer)}>
        <Loader />
      </div>
    );
  }

  const initialFormValues = isUpdate ? existingEventInitialValues : formState;

  return (
    <div className={cx(css.container, 'createZoomLinkContainer')}>
      <h1 className={css.title}>Set up Your Zoom Meeting</h1>
      <ZoomPlanStatusModule containerStyling />
      {!isReview ? (
        <Fragment>
          <h2 className={css.subTitle}>Do You Have a Zoom meeting link for your event?</h2>
          <RadioField
            className={css.marginBottom}
            label="Not yet."
            dek="Don't sweat it! We'll create one for you."
            name="createZoomEvent"
            id="needLink"
            onClick={e => handleSelectForm(e)}
            readOnly
            checked={selectedForm === 'needLink'}
            isExpanded={selectedForm === 'needLink'}
          >
            <CreateZoomEventForm
              handleSaveFormState={handleSaveFormState}
              initialValues={initialFormValues}
              isUpdate={isUpdate}
              onUpdateSuccess={() => {
                handleSetIsReview(true);
              }}
              onCreateSuccess={() => {
                handleSetIsUpdate(true);
                handleSetIsReview(true);
              }}
            />
          </RadioField>
          <RadioField
            className={css.marginBottom}
            label="We do!"
            dek="Make sure it's a scheduled, one-time meeting (not instant or recurring)."
            name="createZoomEvent"
            id="haveLink"
            onClick={e => handleSelectForm(e)}
            readOnly
            checked={selectedForm === 'haveLink'}
            isExpanded={selectedForm === 'haveLink'}
          >
            <ExistingZoomLinkForm
              handleSaveFormState={handleSaveFormState}
              initialValues={initialFormValues}
              isUpdate={isUpdate}
              onUpdateSuccess={() => {
                handleSetIsReview(true);
              }}
              onCreateSuccess={() => {
                handleSetIsUpdate(true);
                handleSetIsReview(true);
              }}
            />
          </RadioField>
        </Fragment>
      ) : (
        <ZoomEventDetailsModule
          zoomEvent={zoomEvent}
          onEditDetails={() => handleSetIsReview(false)}
        />
      )}
    </div>
  );
};

ZoomCreate.defaultProps = {
  zoomEvent: {},
};

export default ZoomCreate;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomCreate/ZoomCreate.jsx